import styled from 'styled-components'

export const StyledTooltipWrapper = styled.div`
  padding: 12px;
  background: ${({ theme }) => theme.colors.BLACK};
  color: ${({ theme }) => theme.colors.WHITE};
  border-radius: 7px;
`
